<template>
    <div>
        <v-container style="max-width: 1300px !important">
            <v-card class="mx-auto my-5 elevation-1" style="margin-bottom: 1rem !important;">
                <v-system-bar class="py-5 px-3 system-bar-title" dark>
                    Personal
                </v-system-bar>
            </v-card>
            <v-card class="mx-auto my-5 elevation-1"
                style="margin-bottom: 2rem !important;padding: 2rem .6rem 0 .6rem;">
                <v-row>
                    <v-col cols="12" lg="3" md="3">
                        <v-text-field max-width="200" class="mx-3" v-model="searchCodPlanilla" label="Código Planilla"
                            append-icon="mdi-magnify" outlined dense></v-text-field>
                    </v-col>
                    <v-col cols="12" lg="3" md="3">
                        <v-text-field max-width="200" class="mx-3" v-model="searchNombreCompleto"
                            label="Nombre Completo" append-icon="mdi-magnify" outlined dense></v-text-field>
                    </v-col>
                    <v-col cols="12" lg="3" md="3">
                        <v-text-field max-width="200" class="mx-3" v-model="searchCargo" label="Cargo"
                            append-icon="mdi-magnify" outlined dense>
                        </v-text-field>
                    </v-col>
                    <v-col cols="12" lg="3" md="3">
                        <v-text-field max-width="200" class="mx-3" v-model="searchCondIngreso" label="Condición Ingreso"
                            append-icon="mdi-magnify" outlined dense>
                        </v-text-field>
                    </v-col>
                    <v-col cols="12" lg="3" md="2">
                        <el-button type="primary" @click="dialogEdit = true">Nuevo</el-button>
                    </v-col>
                </v-row>
            </v-card>
            <v-card class="mx-auto my-5" style=" margin:0 auto;padding: 1.5rem;">
                <div>
                    <v-data-table :headers="filteredHeaders" :items="filteredData" :loading="isLoading" dense
                        loading-text="Cargando... Por favor espere" style="margin: 0 auto;">
                        <template v-slot:[`item.actions`]="{ item }">
                            <v-tooltip top color="green" v-if="!item.estado">
                                <template v-slot:activator="{ on, attrs }">
                                    <v-btn class="mx-2 custom-btn" fab dark color="green" v-bind="attrs" v-on="on"
                                        @click="darAltaUsuario(item)">
                                        <v-icon class="custom-icon" dark>
                                            mdi mdi-transfer-up
                                        </v-icon>
                                    </v-btn>
                                </template>
                                <span>Dar de alta</span>
                            </v-tooltip>
                            <v-tooltip top color="red" v-if="item.estado">
                                <template v-slot:activator="{ on, attrs }">
                                    <v-btn class="mx-2 custom-btn" fab dark color="red" v-bind="attrs" v-on="on"
                                        @click="darBajaUsuario(item)">
                                        <v-icon class="custom-icon" dark>
                                            mdi mdi-transfer-down
                                        </v-icon>
                                    </v-btn>
                                </template>
                                <span>Dar de baja</span>
                            </v-tooltip>
                            <v-tooltip top color="yellow" v-if="item.estado">
                                <template v-slot:activator="{ on, attrs }">
                                    <v-btn class="mx-2 custom-btn" fab dark @click="openEdit(item)" color="yellow"
                                        v-bind="attrs" v-on="on">
                                        <v-icon class="custom-icon" dark>
                                            mdi mdi-account-edit
                                        </v-icon>
                                    </v-btn>
                                </template>
                                <span>Editar</span>
                            </v-tooltip>
                        </template>
                        <template v-slot:[`item.estado`]="{ item }">
                            <span :class="item.estado ? 'activo' : 'desactivado'">
                                {{ item.estado ? 'Activo' : 'Desactivado' }}
                            </span>
                        </template>

                    </v-data-table>
                </div>
            </v-card>
            <el-dialog :title="titleForm" :visible.sync="dialogEdit">
                <el-form :model="personalForm" label-position="top" :rules="rules" ref="personalForm">
                    <el-steps :active="active" finish-status="success">
                        <el-step title="Datos Laborales"></el-step>
                        <el-step title="Datos Financieros"></el-step>
                        <el-step title="Datos Financieros II"></el-step>
                        <el-step title="Datos Financieros III"></el-step>
                    </el-steps>
                    <div v-show="active === 0">
                        <v-row style="margin-top: 1rem;">
                            <v-col cols="12" lg="3" md="6">
                                <el-form-item label="Código Planilla" :label-width="formLabelWidth" prop="cod_planilla">
                                    <el-input v-model="personalForm.cod_planilla" autocomplete="off"></el-input>
                                </el-form-item>
                            </v-col>
                            <v-col cols="12" lg="3" md="6">
                                <el-form-item label="Nombres" :label-width="formLabelWidth" prop="nombres">
                                    <el-input v-model="personalForm.nombres" autocomplete="off"
                                        @input="changeNombreCompleto()"></el-input>
                                </el-form-item>
                            </v-col>
                            <v-col cols="12" lg="3" md="6">
                                <el-form-item label="Apellido Paterno" :label-width="formLabelWidth"
                                    prop="apellido_paterno">
                                    <el-input v-model="personalForm.apellido_paterno" autocomplete="off"
                                        @input="changeNombreCompleto()"></el-input>
                                </el-form-item>
                            </v-col>
                            <v-col cols="12" lg="3" md="6">
                                <el-form-item label="Apellido Materno" :label-width="formLabelWidth"
                                    prop="apellido_materno">
                                    <el-input v-model="personalForm.apellido_materno" autocomplete="off"
                                        @input="changeNombreCompleto()"></el-input>
                                </el-form-item>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="12" lg="3" md="6">
                                <el-form-item label="Fecha Nacimiento" :label-width="formLabelWidth" prop="fecha_nac">
                                    <el-date-picker style="width: 100%;" v-model="personalForm.fecha_nac" type="date"
                                        placeholder="Fecha de Nacimiento" :picker-options="pickerOptions">
                                    </el-date-picker>
                                </el-form-item>
                            </v-col>
                            <v-col cols="12" lg="3" md="6">
                                <el-form-item label="Sexo" :label-width="formLabelWidth" prop="sexo">
                                    <el-select v-model="personalForm.sexo" filterable placeholder="Select"
                                        style="width: 100%;">
                                        <el-option label="Masculino" value="M"></el-option>
                                        <el-option label="Femenino" value="F">
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                            </v-col>
                            <v-col cols="12" lg="3" md="6">
                                <el-form-item label="Dirección" :label-width="formLabelWidth" prop="direccion">
                                    <el-input v-model="personalForm.direccion" autocomplete="off"></el-input>
                                </el-form-item>
                            </v-col>
                            <v-col cols="12" lg="3" md="6">
                                <el-form-item label="Cargo" :label-width="formLabelWidth" prop="cargo">
                                    <el-input v-model="personalForm.cargo" autocomplete="off"></el-input>
                                </el-form-item>
                            </v-col>
                            <v-col cols="12" lg="3" md="6">
                                <el-form-item label="Descripción de Cargo" :label-width="formLabelWidth"
                                    prop="descripcion_cargo">
                                    <el-input v-model="personalForm.descripcion_cargo" autocomplete="off"></el-input>
                                </el-form-item>
                            </v-col>
                            <v-col cols="12" lg="3" md="6">
                                <el-form-item label="Condición de Ingreso" :label-width="formLabelWidth"
                                    prop="cond_ingreso">
                                    <el-input v-model="personalForm.cond_ingreso" autocomplete="off"></el-input>
                                </el-form-item>
                            </v-col>
                            <v-col cols="12" lg="3" md="6">
                                <el-form-item label="Horario" :label-width="formLabelWidth" prop="horario_id">
                                    <el-select v-model="personalForm.horario_id" filterable placeholder="Select"
                                        style="width: 100%;">
                                        <el-option v-for="item in arrayHorarios" :key="item.id" :label="item.horario"
                                            :value="item.id"></el-option>
                                    </el-select>
                                </el-form-item>
                            </v-col>
                        </v-row>
                    </div>
                    <div v-show="active === 1">
                        <v-row style="margin-top: 1rem;">
                            <v-col cols="12" lg="3" md="6">
                                <el-form-item label="Código Dep" :label-width="formLabelWidth" prop="codigo_dep">
                                    <el-input v-model="personalForm.codigo_dep" autocomplete="off"></el-input>
                                </el-form-item>
                            </v-col>
                            <v-col cols="12" lg="3" md="6">
                                <el-form-item label="Cuenta Corriente" :label-width="formLabelWidth" prop="cuenta_cor">
                                    <el-input v-model="personalForm.cuenta_cor" autocomplete="off"></el-input>
                                </el-form-item>
                            </v-col>
                            <v-col cols="12" lg="3" md="6">
                                <el-form-item label="Código Bancario" :label-width="formLabelWidth" prop="codigo_ban">
                                    <el-input v-model="personalForm.codigo_ban" autocomplete="off"></el-input>
                                </el-form-item>
                            </v-col>
                            <v-col cols="12" lg="3" md="6">
                                <el-form-item label="Cuenta CTS" :label-width="formLabelWidth" prop="cuenta_cts">
                                    <el-input v-model="personalForm.cuenta_cts" autocomplete="off"></el-input>
                                </el-form-item>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="12" lg="3" md="6">
                                <el-form-item label="Banco CTS" :label-width="formLabelWidth" prop="banco_cts">
                                    <el-input v-model="personalForm.banco_cts" autocomplete="off"></el-input>
                                </el-form-item>
                            </v-col>
                            <v-col cols="12" lg="3" md="6">
                                <el-form-item label="Código Lin" :label-width="formLabelWidth" prop="codigo_lin">
                                    <el-input v-model="personalForm.codigo_lin" autocomplete="off"></el-input>
                                </el-form-item>
                            </v-col>
                            <v-col cols="12" lg="3" md="6">
                                <el-form-item label="Descripción Lin" :label-width="formLabelWidth" prop="descri_lin">
                                    <el-input v-model="personalForm.descri_lin" autocomplete="off"></el-input>
                                </el-form-item>
                            </v-col>
                            <v-col cols="12" lg="3" md="6">
                                <el-form-item label="Código Linant" :label-width="formLabelWidth" prop="cod_linant">
                                    <el-input v-model="personalForm.cod_linant" autocomplete="off"></el-input>
                                </el-form-item>
                            </v-col>
                            <v-col cols="12" lg="3" md="6">
                                <el-form-item label="Grupo Ocupacional" :label-width="formLabelWidth" prop="grupo_ocup">
                                    <el-input v-model="personalForm.grupo_ocup" autocomplete="off"></el-input>
                                </el-form-item>
                            </v-col>
                            <v-col cols="12" lg="3" md="6">
                                <el-form-item label="Exoneración" :label-width="formLabelWidth" prop="exone">
                                    <el-input v-model="personalForm.exone" autocomplete="off"></el-input>
                                </el-form-item>
                            </v-col>
                            <v-col cols="12" lg="3" md="6">
                                <el-form-item label="Por ZMD" :label-width="formLabelWidth" prop="por_zmd">
                                    <el-input v-model="personalForm.por_zmd" autocomplete="off"></el-input>
                                </el-form-item>
                            </v-col>
                            <v-col cols="12" lg="3" md="6">
                                <el-form-item label="Código SPP" :label-width="formLabelWidth" prop="codigo_spp">
                                    <el-input v-model="personalForm.codigo_spp" autocomplete="off"></el-input>
                                </el-form-item>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="12" lg="3" md="6">
                                <el-form-item label="Código SAP" :label-width="formLabelWidth" prop="codigo_sap">
                                    <el-input v-model="personalForm.codigo_sap" autocomplete="off"></el-input>
                                </el-form-item>
                            </v-col>
                            <v-col cols="12" lg="3" md="6">
                                <el-form-item label="Fecha Cambio" :label-width="formLabelWidth" prop="fecha_camb">
                                    <el-date-picker style="width: 100%;" v-model="personalForm.fecha_camb" type="date"
                                        placeholder="Fecha Cambio" :picker-options="pickerOptions">
                                    </el-date-picker>
                                </el-form-item>
                            </v-col>
                            <v-col cols="12" lg="3" md="6">
                                <el-form-item label="Fecha IAFP" :label-width="formLabelWidth" prop="fecha_iafp">
                                    <el-date-picker style="width: 100%;" v-model="personalForm.fecha_iafp" type="date"
                                        placeholder="Fecha IAFP" :picker-options="pickerOptions">
                                    </el-date-picker>
                                </el-form-item>
                            </v-col>
                        </v-row>
                    </div>
                    <div v-show="active === 2">
                        <v-row style="margin-top: 1rem;">
                            <v-col cols="12" lg="3" md="6">
                                <el-form-item label="Código NIV" :label-width="formLabelWidth" prop="codigo_niv">
                                    <el-input v-model="personalForm.codigo_niv" autocomplete="off"></el-input>
                                </el-form-item>
                            </v-col>
                            <v-col cols="12" lg="3" md="6">
                                <el-form-item label="Descripción NIV" :label-width="formLabelWidth" prop="descri_niv">
                                    <el-input v-model="personalForm.descri_niv" autocomplete="off"></el-input>
                                </el-form-item>
                            </v-col>
                            <v-col cols="12" lg="3" md="6">
                                <el-form-item label="Código ESP" :label-width="formLabelWidth" prop="codigo_esp">
                                    <el-input v-model="personalForm.codigo_esp" autocomplete="off"></el-input>
                                </el-form-item>
                            </v-col>
                            <v-col cols="12" lg="3" md="6">
                                <el-form-item label="Área Ubicación" :label-width="formLabelWidth" prop="area_ubica">
                                    <el-input v-model="personalForm.area_ubica" autocomplete="off"></el-input>
                                </el-form-item>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="12" lg="3" md="6">
                                <el-form-item label="Función" :label-width="formLabelWidth" prop="funcion">
                                    <el-input v-model="personalForm.funcion" autocomplete="off"></el-input>
                                </el-form-item>
                            </v-col>
                            <v-col cols="12" lg="3" md="6">
                                <el-form-item label="OODD" :label-width="formLabelWidth" prop="oodd">
                                    <el-input v-model="personalForm.oodd" autocomplete="off"></el-input>
                                </el-form-item>
                            </v-col>
                            <v-col cols="12" lg="3" md="6">
                                <el-form-item label="Fecha ULQU" :label-width="formLabelWidth" prop="fecha_ulqu">
                                    <el-input v-model="personalForm.fecha_ulqu" autocomplete="off"></el-input>
                                </el-form-item>
                            </v-col>
                            <v-col cols="12" lg="3" md="6">
                                <el-form-item label="Quin Recon" :label-width="formLabelWidth" prop="quin_recon">
                                    <el-input v-model="personalForm.quin_recon" autocomplete="off"></el-input>
                                </el-form-item>
                            </v-col>
                            <v-col cols="12" lg="3" md="6">
                                <el-form-item label="Acumula Falta" :label-width="formLabelWidth" prop="acum_falta">
                                    <el-input v-model="personalForm.acum_falta" autocomplete="off"></el-input>
                                </el-form-item>
                            </v-col>
                            <v-col cols="12" lg="3" md="6">
                                <el-form-item label="Tiempo Servicio" :label-width="formLabelWidth" prop="tiemp_serv">
                                    <el-input v-model="personalForm.tiemp_serv" autocomplete="off"></el-input>
                                </el-form-item>
                            </v-col>
                            <v-col cols="12" lg="3" md="6">
                                <el-form-item label="Nume Cipss" :label-width="formLabelWidth" prop="nume_cipss">
                                    <el-input v-model="personalForm.nume_cipss" autocomplete="off"></el-input>
                                </el-form-item>
                            </v-col>
                            <v-col cols="12" lg="3" md="6">
                                <el-form-item label="Centro Asist" :label-width="formLabelWidth" prop="cent_asist">
                                    <el-input v-model="personalForm.cent_asist" autocomplete="off"></el-input>
                                </el-form-item>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="12" lg="3" md="6">
                                <el-form-item label="Tipo Persona" :label-width="formLabelWidth" prop="tipo_perso">
                                    <el-input v-model="personalForm.tipo_perso" autocomplete="off"></el-input>
                                </el-form-item>
                            </v-col>
                            <v-col cols="12" lg="3" md="6">
                                <el-form-item label="Regi Pensi" :label-width="formLabelWidth" prop="regi_pensi">
                                    <el-input v-model="personalForm.regi_pensi" autocomplete="off"></el-input>
                                </el-form-item>
                            </v-col>
                            <v-col cols="12" lg="3" md="6">
                                <el-form-item label="Código AFP" :label-width="formLabelWidth" prop="codi_afp">
                                    <el-input v-model="personalForm.codi_afp" autocomplete="off"></el-input>
                                </el-form-item>
                            </v-col>
                            <v-col cols="12" lg="3" md="6">
                                <el-form-item label="Éxonera AFP" :label-width="formLabelWidth" prop="exoneafp">
                                    <el-input v-model="personalForm.exoneafp" autocomplete="off"></el-input>
                                </el-form-item>
                            </v-col>
                        </v-row>
                    </div>
                    <div v-show="active === 3">
                        <v-row style="margin-top: 1rem;">
                            <v-col cols="12" lg="3" md="6">
                                <el-form-item label="Situación" :label-width="formLabelWidth" prop="situacion">
                                    <el-input v-model="personalForm.situacion" autocomplete="off"></el-input>
                                </el-form-item>
                            </v-col>
                            <v-col cols="12" lg="3" md="6">
                                <el-form-item label="Designación" :label-width="formLabelWidth" prop="designacio">
                                    <el-input v-model="personalForm.designacio" autocomplete="off"></el-input>
                                </el-form-item>
                            </v-col>
                            <v-col cols="12" lg="3" md="6">
                                <el-form-item label="Mes Vacaciones" :label-width="formLabelWidth" prop="mes_vacaci">
                                    <el-input v-model="personalForm.mes_vacaci" autocomplete="off"></el-input>
                                </el-form-item>
                            </v-col>
                            <v-col cols="12" lg="3" md="6">
                                <el-form-item label="Lib Electo" :label-width="formLabelWidth" prop="lib_electo">
                                    <el-input v-model="personalForm.lib_electo" autocomplete="off"></el-input>
                                </el-form-item>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="12" lg="3" md="6">
                                <el-form-item label="Estado Civil" :label-width="formLabelWidth" prop="esta_civil">
                                    <el-input v-model="personalForm.esta_civil" autocomplete="off"></el-input>
                                </el-form-item>
                            </v-col>
                            <v-col cols="12" lg="3" md="6">
                                <el-form-item label="Tipo Documento" :label-width="formLabelWidth" prop="tipo_doc">
                                    <el-input v-model="personalForm.tipo_doc" autocomplete="off"></el-input>
                                </el-form-item>
                            </v-col>
                            <v-col cols="12" lg="3" md="6">
                                <el-form-item label="Periodo" :label-width="formLabelWidth" prop="periodo">
                                    <el-input v-model="personalForm.periodo" autocomplete="off"></el-input>
                                </el-form-item>
                            </v-col>
                            <v-col cols="12" lg="3" md="6">
                                <el-form-item label="Totai" :label-width="formLabelWidth" prop="totai">
                                    <el-input v-model="personalForm.totai" autocomplete="off"></el-input>
                                </el-form-item>
                            </v-col>
                            <v-col cols="12" lg="3" md="6">
                                <el-form-item label="Totad" :label-width="formLabelWidth" prop="totad">
                                    <el-input v-model="personalForm.totad" autocomplete="off"></el-input>
                                </el-form-item>
                            </v-col>
                            <v-col cols="12" lg="3" md="6">
                                <el-form-item label="Porc Aum" :label-width="formLabelWidth" prop="porc_aum">
                                    <el-input v-model="personalForm.porc_aum" autocomplete="off"></el-input>
                                </el-form-item>
                            </v-col>
                            <v-col cols="12" lg="3" md="6">
                                <el-form-item label="Remuneración" :label-width="formLabelWidth" prop="remunera">
                                    <el-input v-model="personalForm.remunera" autocomplete="off"></el-input>
                                </el-form-item>
                            </v-col>
                            <v-col cols="12" lg="3" md="6">
                                <el-form-item label="Enc Palz" :label-width="formLabelWidth" prop="enc_plaz">
                                    <el-input v-model="personalForm.enc_plaz" autocomplete="off"></el-input>
                                </el-form-item>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="12" lg="3" md="6">
                                <el-form-item label="Bonificación" :label-width="formLabelWidth" prop="bonifica">
                                    <el-input v-model="personalForm.bonifica" autocomplete="off"></el-input>
                                </el-form-item>
                            </v-col>
                            <v-col cols="12" lg="3" md="6">
                                <el-form-item label="Liberados" :label-width="formLabelWidth" prop="liberados">
                                    <el-input v-model="personalForm.liberados" autocomplete="off"></el-input>
                                </el-form-item>
                            </v-col>
                            <v-col cols="12" lg="3" md="6">
                                <el-form-item label="Días Licencia" :label-width="formLabelWidth" prop="dias_licen">
                                    <el-input v-model="personalForm.dias_licen" autocomplete="off"></el-input>
                                </el-form-item>
                            </v-col>
                            <v-col cols="12" lg="3" md="6">
                                <el-form-item label="Días Falta" :label-width="formLabelWidth" prop="dias_falta">
                                    <el-input v-model="personalForm.dias_falta" autocomplete="off"></el-input>
                                </el-form-item>
                            </v-col>
                        </v-row>
                    </div>
                    <el-button @click="closeEdit" v-if="active === 0">Cancelar</el-button>
                    <el-button style="margin-top: 12px;" @click="prev" v-if="active !== 0">Anterior</el-button>
                    <el-button style="margin-top: 12px;" @click="next" v-if="active !== 3">Siguiente</el-button>
                    <el-button type="primary" @click="submitForm('personalForm')"
                        v-if="!statusEdit && active === 3">Confirmar</el-button>
                    <el-button type="primary" @click="editForm('personalForm')" v-if="statusEdit">Guardar</el-button>
                    <!-- </span> -->
                </el-form>
            </el-dialog>
            <v-dialog v-model="dialogLoader" persistent width="300"
                style="padding: 1rem;overflow: hidden !important;background: white !important;">
                <v-progress-circular :size="80" color="primary" :width="5" indeterminate></v-progress-circular>
            </v-dialog>
        </v-container>
    </div>
</template>
<script>
import axios from "axios";
export const RUTA_SERVIDOR = process.env.VUE_APP_API;
export const USUARIO = process.env.VUE_APP_USERNAME;
export const PASSWORD = process.env.VUE_APP_PASSWORD;
export const RUTA_API = process.env.VUE_APP_API;
import Swal from "sweetalert2";
export default {
    data() {
        return {
            pickerOptions: {
                disabledDate(time) {
                    return time.getTime() > Date.now();
                },
            },
            active: 0,
            rules: {
                cod_planilla: [
                    { required: true, message: 'Este campo es obligatorio.', trigger: 'blur' }
                ],
                nombres: [
                    { required: true, message: 'Este campo es obligatorio.', trigger: 'blur' }
                ],
                apellido_paterno: [
                    { required: true, message: 'Este campo es obligatorio.', trigger: 'blur' }
                ],
                apellido_materno: [
                    { required: true, message: 'Este campo es obligatorio.', trigger: 'blur' }
                ],
                sexo: [
                    { required: true, message: 'Este campo es obligatorio.', trigger: 'blur' }
                ],
                direccion: [
                    { required: true, message: 'Este campo es obligatorio.', trigger: 'blur' }
                ],
                cargo: [
                    { required: true, message: 'Este campo es obligatorio.', trigger: 'blur' }
                ],
                descripcion_cargo: [
                    { required: true, message: 'Este campo es obligatorio.', trigger: 'blur' }
                ],
                cond_ingreso: [
                    { required: true, message: 'Este campo es obligatorio.', trigger: 'blur' }
                ],
                horario_id: [
                    { required: true, message: 'Este campo es obligatorio.', trigger: 'blur' }
                ],
                fecha_nac: [
                    { required: true, message: 'Este campo es obligatorio.', trigger: 'blur' }
                ],
            },
            titleForm: 'Nuevo Personal',
            formLabelWidth: '70px',
            valid: true,
            idPersonal: null,
            titleButton: 'Guardar',
            personalForm: {
                cod_planilla: null,
                nombre_completo: null,
                apellido_paterno: "",
                apellido_materno: "",
                nombres: "",
                cargo: null,
                cond_ingreso: null,
                horario: null,
                descripcion_cargo: null,
                estado: true,
                horario_id: null,
                fecha_nac: null,
                direccion: null,
                codigo_dep: null,
                cuenta_cor: null,
                codigo_ban: null,
                cuenta_cts: null,
                banco_cts: null,
                codigo_lin: null,
                descri_lin: null,
                cod_linant: null,
                grupo_ocup: null,
                exone: null,
                por_zmd: null,
                codigo_spp: null,
                codigo_sap: null,
                fecha_camb: null,
                fecha_iafp: null,
                /* Step 3 */
                codigo_niv: null,
                descri_niv: null,
                codigo_esp: null,
                area_ubica: null,
                funcion: null,
                oodd: null,
                fecha_ulqu: null,
                quin_recon: null,
                acum_falta: null,
                tiemp_serv: null,
                nume_cipss: null,
                cent_asist: null,
                tipo_perso: null,
                regi_pensi: null,
                codi_afp: null,
                exoneafp: null,
                /* Step 4 */
                situacion: null,
                designacio: null,
                mes_vacaci: null,
                lib_electo: null,
                esta_civil: null,
                tipo_doc: null,
                periodo: null,
                totai: null,
                totad: null,
                porc_aum: null,
                remunera: null,
                enc_plaz: null,
                bonifica: null,
                liberados: null,
                dias_licen: null,
                dias_falta: null

            },
            searchSala: [],
            statusEdit: false,
            modal: false,
            searchCodPlanilla: null,
            searchNombreCompleto: null,
            searchCargo: null,
            searchCondIngreso: null,
            dialogImport: false,
            dialogLoader: false,
            ver: false,
            searchDocumento: "",
            dataPaciente: [],
            date1: new Date()
                .toISOString()
                .substr(0, 10),
            search: "",
            sortBy: [{ key: "cupos_disponible", order: "asc" }],
            headers: [
                { text: "Código Planilla", value: "cod_planilla" },
                { text: "Nombres Completos", value: "nombre_completo" },
                { text: "Cargo", value: "cargo" },
                { text: "Descripción de Cargo", value: "descripcion_cargo", align: "center" },
                { text: "Condición de Ingreso", value: "cond_ingreso" },
                { text: "Estado", value: "estado" },
                { text: "Acciones", value: "actions", align: "right" }
            ],
            dialogEdit: false,
            dialogDelete: false,
            isLoading: false,
            dataArray: [],
            arrayAreas: [],
            arrayRoles: [],
            dataUsuariosHisar: [],
            arrayHorarios: []
        };
    },
    watch: {
        dialogEdit(newVal, oldVal) {
            if (newVal) {
                console.log("El diálogo se abrió.");
            } else {
                this.closeEdit();
                console.log("El diálogo se cerró.");
            }
        },
    },
    methods: {
        loadHorarios() {
            axios
                .get(RUTA_API + "/rrhh_planilla_horarios/")
                .then((res) => {
                    this.arrayHorarios = res.data;
                })
                .catch((res) => {
                });

        },
        prev() {
            this.active--;
        },
        next() {
            this.active++;
        },
        editForm(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.edit();
                } else {
                    return false;
                }
            });
        },
        submitForm(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.save();
                } else {
                    return false;
                }
            });
        },
        resetForm(formName) {
            this.$refs[formName].resetFields();
        },
        changeNombreCompleto() {
            this.personalForm.nombre_completo = this.personalForm.nombres + " " + this.personalForm.apellido_paterno + " " + this.personalForm.apellido_materno;
        },
        darAltaUsuario(item) {
            Swal.fire({
                title: "¡Alerta!",
                text: "¿Esta seguro de dar de alta al personal?",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                cancelButtonColor: "#d33",
                confirmButtonText: "Aceptar"
            }).then((result) => {
                // Este bloque se ejecutará cuando el usuario haga clic en el botón de confirmación
                if (result.isConfirmed) {
                    this.dialogLoader = true;
                    axios
                        .post(RUTA_API + "/api/token/", {
                            username: USUARIO,
                            password: PASSWORD,
                        })
                        .then((response) => {
                            this.auth = "Bearer " + response.data.access;
                            axios
                                .patch(RUTA_API + "/rrhh_planilla_personal/" + item.id + "/", {
                                    estado: true
                                }, {
                                    headers: { Authorization: this.auth },
                                })
                                .then((res) => {
                                    Swal.fire({
                                        title: "¡Exito!",
                                        icon: "success",
                                        draggable: true
                                    });
                                    this.dialogLoader = false;
                                    this.dataInit();

                                })
                                .catch((res) => {

                                });
                        })
                        .catch((response) => {
                            response === 404
                                ? console.warn("lo sientimos no tenemos servicios")
                                : console.warn("Error:", response);
                        });

                }
            });
        },
        darBajaUsuario(item) {
            Swal.fire({
                title: "¡Alerta!",
                text: "¿Esta seguro de dar de baja al personal?",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                cancelButtonColor: "#d33",
                confirmButtonText: "Aceptar"
            }).then((result) => {
                // Este bloque se ejecutará cuando el usuario haga clic en el botón de confirmación
                if (result.isConfirmed) {
                    this.dialogLoader = true;
                    axios
                        .post(RUTA_API + "/api/token/", {
                            username: USUARIO,
                            password: PASSWORD,
                        })
                        .then((response) => {
                            this.auth = "Bearer " + response.data.access;
                            axios
                                .patch(RUTA_API + "/rrhh_planilla_personal/" + item.id + "/", {
                                    estado: false
                                }, {
                                    headers: { Authorization: this.auth },
                                })
                                .then((res) => {
                                    Swal.fire({
                                        title: "¡Exito!",
                                        icon: "success",
                                        draggable: true
                                    });
                                    this.dialogLoader = false;
                                    this.dataInit();

                                })
                                .catch((res) => {

                                });
                        })
                        .catch((response) => {
                            response === 404
                                ? console.warn("lo sientimos no tenemos servicios")
                                : console.warn("Error:", response);
                        });

                }
            });
        },
        clearForm() {
            this.personalForm= {
                cod_planilla: null,
                nombre_completo: null,
                apellido_paterno: "",
                apellido_materno: "",
                nombres: "",
                cargo: null,
                cond_ingreso: null,
                horario: null,
                descripcion_cargo: null,
                estado: true,
                horario_id: null,
                fecha_nac: null,
                direccion: null,
                codigo_dep: null,
                cuenta_cor: null,
                codigo_ban: null,
                cuenta_cts: null,
                banco_cts: null,
                codigo_lin: null,
                descri_lin: null,
                cod_linant: null,
                grupo_ocup: null,
                exone: null,
                por_zmd: null,
                codigo_spp: null,
                codigo_sap: null,
                fecha_camb: null,
                fecha_iafp: null,
                /* Step 3 */
                codigo_niv: null,
                descri_niv: null,
                codigo_esp: null,
                area_ubica: null,
                funcion: null,
                oodd: null,
                fecha_ulqu: null,
                quin_recon: null,
                acum_falta: null,
                tiemp_serv: null,
                nume_cipss: null,
                cent_asist: null,
                tipo_perso: null,
                regi_pensi: null,
                codi_afp: null,
                exoneafp: null,
                /* Step 4 */
                situacion: null,
                designacio: null,
                mes_vacaci: null,
                lib_electo: null,
                esta_civil: null,
                tipo_doc: null,
                periodo: null,
                totai: null,
                totad: null,
                porc_aum: null,
                remunera: null,
                enc_plaz: null,
                bonifica: null,
                liberados: null,
                dias_licen: null,
                dias_falta: null

            }
        },
        openEdit(item) {
            this.titleForm = 'Editar Usuario',
                this.statusEdit = true;
            this.idPersonal = item.id;
            this.dialogEdit = true;
            this.personalForm.cod_planilla = item.cod_planilla;
            this.personalForm.nombres = item.nombres;
            this.personalForm.nombre_completo = item.nombre_completo;
            this.personalForm.estado = item.estado;
            this.personalForm.apellido_paterno = item.apellido_paterno;
            this.personalForm.apellido_materno = item.apellido_materno;
            this.personalForm.cargo = item.cargo;
            this.personalForm.descripcion_cargo = item.descripcion_cargo;
            this.personalForm.cond_ingreso = item.cond_ingreso;
            this.personalForm.horario_id = item.horario_id;
        },
        closeEdit() {
            this.active=0;
            this.resetForm('personalForm');
            this.statusEdit = false;
            this.dialogEdit = false;
            this.titleForm = 'Nuevo Personal';
            this.clearForm();
        },
        save() {
            this.dialogLoader = true;
            axios
                .post(RUTA_API + "/api/token/", {
                    username: USUARIO,
                    password: PASSWORD,
                })
                .then((response) => {
                    this.auth = "Bearer " + response.data.access;
                    axios
                        .post(RUTA_API + "/rrhh_planilla_personal/", this.personalForm, {
                            headers: { Authorization: this.auth },
                        })
                        .then((res) => {
                            Swal.fire({
                                title: "¡Exito!",
                                text: "El usuario se registró con exito.",
                                icon: "success",
                                draggable: true
                            });
                            this.dialogEdit = false;
                            this.dataInit();
                            this.dialogLoader = false;
                            this.clearForm();
                            this.statusEdit = false;
                        })
                        .catch((res) => {
                            this.dialogEdit = false;
                            console.log("Error:", res);
                            this.dialogLoader = false;
                        });
                })
                .catch((response) => {
                    response === 404
                        ? console.warn("lo sientimos no tenemos servicios")
                        : console.warn("Error:", response);
                });
        },
        edit() {
            this.dialogLoader = true;
            this.statusEdit = true;
            this.dialogEdit = false;
            axios
                .put(RUTA_API + "/rrhh_planilla_personal/" + this.idPersonal + "/", this.personalForm)
                .then((res) => {
                    Swal.fire({
                        title: "¡Exito!",
                        text: "El personal se editó con exito.",
                        icon: "success",
                        draggable: true
                    });
                    this.dataInit();
                    this.dialogLoader = false;
                    this.statusEdit = false;
                })
                .catch((res) => {
                    console.log("Error:", res);
                });

        },
        dataInit() {
            this.dialogLoader = true;
            axios
                .post(RUTA_API + "/api/token/", {
                    username: USUARIO,
                    password: PASSWORD,
                })
                .then((response) => {
                    this.auth = "Bearer " + response.data.access;
                    axios
                        .get(RUTA_API + "/rrhh_planilla_personal/", {
                            headers: { Authorization: this.auth },
                        })
                        .then((res) => {
                            this.dialogLoader = false;
                            this.dataPaciente = res.data;

                        })
                        .catch((res) => {
                            this.dialogLoader = false;
                            console.log("Error:", res);
                        });
                })
                .catch((response) => {
                    this.dialogLoader = false;
                    response === 404
                        ? console.warn("lo sientimos no tenemos servicios")
                        : console.warn("Error:", response);
                });
        },
    },
    mounted() { },
    computed: {
        filteredHeaders() {
            return this.headers;
        },
        filteredData() {
            if (!this.searchCodPlanilla && !this.searchNombreCompleto && !this.searchCargo && !this.searchCondIngreso) {
                return this.dataPaciente;
            }
            let filtered = this.dataPaciente;
            if (this.searchCodPlanilla) {
                filtered = filtered.filter((item) => {
                    const nombreCompleto = item.cod_planilla;
                    return nombreCompleto.toLowerCase().includes(this.searchCodPlanilla.toLowerCase());
                });
            }
            if (this.searchNombreCompleto) {
                filtered = filtered.filter((item) =>
                    item.nombre_completo
                        .toLowerCase()
                        .includes(this.searchNombreCompleto.toLowerCase())
                );
            }
            if (this.searchCargo) {
                filtered = filtered.filter((item) =>
                    item.cargo
                        .toLowerCase()
                        .includes(this.searchCargo.toLowerCase())
                );
            }
            if (this.searchCondIngreso) {
                filtered = filtered.filter((item) =>
                    item.cond_ingreso
                        .toLowerCase()
                        .includes(this.searchCondIngreso.toLowerCase())
                );
            }
            return filtered;
        },
    },
    created() {
        this.dataInit();
        this.loadHorarios();
    },
    components: {},
};
</script>
<style scoped>
::v-deep .el-dialog {
    width: 75%;
    margin-top: 3% !important;
    margin-bottom: 3% !important;
}

::v-deep .el-dialog,
.el-form,
.el-input,
.el-button,
.el-date-picker,
.el-table,
.el-picker-panel__body,
.el-select {
    font-family: "Roboto", sans-serif !important;
}

.el-form-item__label {
    line-height: 0px !important;
}

.activo {
    color: rgb(255, 255, 255);
    background: #74d467;
    padding: 0.2rem .7rem;
    border-radius: .4rem;
    font-size: 12px;
}

.desactivado {
    color: rgb(255, 255, 255);
    background: #df4141;
    padding: 0.2rem .7rem;
    border-radius: .4rem;
    font-size: 12px;
}

::v-deep .theme--dark.v-system-bar {
    color: hsl(0, 0%, 100%) !important;
}

.layout-loading {
    align-items: center;
    display: flex;
    height: 100%;
    justify-content: center;
    left: 0;
    pointer-events: none;
    position: fixed;
    top: 0;
    transition: 0.2s cubic-bezier(0.25, 0.8, 0.25, 1), z-index 1ms;
    width: 100%;
    z-index: 202;
    background: #e3e3e3b1;
}

::v-deep .v-dialog {
    display: flex;
    justify-content: center;
    box-shadow: none;
    overflow-y: hidden !important;
}

.system-bar-title {
    display: flex;
    justify-content: space-between;
    color: white;
    padding: 1.2rem 1.4rem !important;
}

::v-deep tr th {
    text-wrap: nowrap !important;
}

::v-deep .v-card {
    box-shadow: 0px 0px 11px 6px rgb(15 61 99 / 27%) !important;
}

::v-deep tr td {
    text-wrap: nowrap !important;
}

::v-deep .theme--dark.v-system-bar {
    background: #1780cd;
}

.custom-btn {
    width: 25px !important;
    height: 25px !important;
}

.custom-icon {
    font-size: 20px !important;
}

.bg-primary-table {
    font-weight: 400;
}

.text-start {
    font-size: 0.8rem !important;
}

.container {
    max-width: 3000px !important;
}

td {
    white-space: nowrap;
}
</style>